var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrecruitment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6583 23.1182L31.6905 32.1505M15.1314 26.129C9.31161 26.129 4.59375 21.4111 4.59375 15.5913C4.59375 9.77157 9.31161 5.05371 15.1314 5.05371C20.9512 5.05371 25.669 9.77157 25.669 15.5913C25.669 21.4111 20.9512 26.129 15.1314 26.129Z",
    stroke: "white",
    strokeWidth: 1.72043,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrecruitment);
export default __webpack_public_path__ + "static/media/Wrecruitment.de31d4063ebad9c6898c2deff98bb508.svg";
export { ForwardRef as ReactComponent };